// label 자동 변환 함수: FLEA_BEETLE → Flea Beetle
export const formatReadableName = (raw) => {
  if (!raw) return "";
  return raw
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
